function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M0.383,9.883c0-5.25,4.25-9.517,9.517-9.517c5.25,0,9.516,4.25,9.516,9.517 c0,5.25-4.25,9.517-9.516,9.517C4.633,19.4,0.383,15.133,0.383,9.883L0.383,9.883z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#SVGID_2_)",
  d: "M0.567,9.9c0-5.15,4.183-9.333,9.333-9.333S19.233,4.75,19.233,9.9S15.05,19.233,9.9,19.233 S0.567,15.05,0.567,9.9L0.567,9.9z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#76231F",
  d: "M8.35,12.367c-0.083,0.549,0.167,0.85,0.667,0.699c0.333-0.1,0.65-0.366,0.85-0.699H9.4 c-0.1,0.133-0.2,0.199-0.283,0.217c-0.1,0.033-0.25,0.016-0.25-0.217H8.35L8.35,12.367z M10.383,12.367 c0.117,0.149,0.317,0.199,0.583,0.116c0.1-0.033,0.184-0.067,0.283-0.116H10.383L10.383,12.367z"
}), React.createElement("path", {
  fill: "#76231F",
  d: "M8.867,12.367c0-0.067,0-0.134,0.017-0.217c0.083-0.434,0.317-0.601,0.45-0.634s0.316,0,0.233,0.434 c-0.034,0.183-0.1,0.316-0.167,0.417h0.467C9.967,12.2,10.05,12,10.083,11.8c0.117-0.6-0.15-0.917-0.667-0.767 S8.467,11.717,8.35,12.3c0,0.017,0,0.05-0.017,0.067H8.867L8.867,12.367z M11.233,12.367c0.384-0.234,0.683-0.667,0.783-1.15 c0.116-0.6-0.149-0.917-0.667-0.767c-0.516,0.149-0.95,0.683-1.066,1.267c-0.05,0.283-0.017,0.5,0.083,0.65H11.233L11.233,12.367z M14.05,9.583l-0.6,0.183l-0.583,1.366l0,0L12.816,10l-0.583,0.167L12.4,12.05l0.616-0.216L14.05,9.583L14.05,9.583z M14.3,9.5 l1.167-0.35l-0.1,0.517L14.75,9.883l-0.05,0.25l0.517-0.2l-0.084,0.517l-0.516,0.167l-0.051,0.25l0.634-0.234l-0.134,0.584 l-1.184,0.367L14.3,9.5L14.3,9.5z M10.816,11.566c0.084-0.434,0.316-0.6,0.45-0.633s0.317,0,0.233,0.434 c-0.084,0.433-0.316,0.6-0.45,0.633S10.733,12,10.816,11.566L10.816,11.566z M15.584,11.017l0.6-0.167l0.166-0.816L16.617,10 c0.232-0.067,0.199,0.133,0.183,0.317c-0.017,0.1-0.033,0.2-0.017,0.3l0.566-0.15c-0.033-0.083,0.018-0.317,0.033-0.417 c0.033-0.25-0.033-0.4-0.166-0.417C17.416,9.5,17.55,9.267,17.6,9.05c0.084-0.383-0.166-0.5-0.482-0.4L16,8.967L15.584,11.017 L15.584,11.017z M16.483,9.283l0.267-0.066c0.217-0.067,0.267,0,0.25,0.117c-0.033,0.183-0.184,0.233-0.3,0.267l-0.3,0.066 L16.483,9.283L16.483,9.283z"
}), React.createElement("path", {
  fill: "#76231F",
  d: "M1.6,10.183c0-4.683,3.8-8.5,8.5-8.5c4.683,0,8.5,3.8,8.5,8.5c0,4.684-3.8,8.5-8.5,8.5 C5.4,18.666,1.6,14.867,1.6,10.183L1.6,10.183z M17.666,7.9l-9.383,2.983l-1.716,6.384C7.633,17.8,8.833,18.1,10.1,18.1 c4.367,0,7.9-3.533,7.9-7.899C18,9.383,17.883,8.617,17.666,7.9L17.666,7.9z M8,2.55l-2.333,8.733l2.034-0.65L9.083,5.45 l0.683-0.2L8.383,10.4l9.15-2.9c-1.1-3.05-4.017-5.25-7.45-5.25C9.367,2.267,8.667,2.367,8,2.55L8,2.55z M2.467,12.3l2.5-0.8 L7.3,2.767c-3,1.133-5.117,4.017-5.117,7.4C2.183,10.916,2.283,11.633,2.467,12.3L2.467,12.3z M6.017,16.95l1.567-5.866 l-2.05,0.649L4.917,14l-0.683,0.2l0.6-2.25l-2.25,0.716C3.183,14.483,4.417,16,6.017,16.95L6.017,16.95z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "13.633,11.4 14.834,11.033 14.95,10.45 14.334,10.684 14.383,10.433 14.9,10.283 14.983,9.767  14.483,9.967 14.517,9.717 15.133,9.483 15.233,8.983 14.084,9.333 \t\t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M9.2,10.867c-0.517,0.149-0.95,0.683-1.067,1.266c0,0.018,0,0.051-0.017,0.067h0.517 c0-0.05,0-0.134,0.017-0.217c0.083-0.434,0.317-0.601,0.45-0.634s0.316,0,0.233,0.434C9.3,11.967,9.233,12.1,9.167,12.2l0,0 c-0.1,0.134-0.2,0.2-0.283,0.216c-0.1,0.034-0.25,0.018-0.25-0.216H8.117c-0.083,0.55,0.183,0.85,0.667,0.7 c0.333-0.101,0.65-0.367,0.85-0.7c0.1-0.167,0.184-0.366,0.217-0.567C9.967,11.033,9.717,10.717,9.2,10.867z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M17.367,8.9c0.083-0.383-0.167-0.5-0.484-0.4l-1.1,0.3l-0.416,2.067l0.6-0.167l0.166-0.817L16.4,9.85 c0.232-0.067,0.199,0.133,0.184,0.316c-0.018,0.1-0.018,0.2-0.018,0.3l0.566-0.15C17.1,10.233,17.15,10,17.166,9.9 C17.2,9.65,17.133,9.5,17,9.483C17.184,9.35,17.316,9.1,17.367,8.9z M16.767,9.167c-0.033,0.184-0.183,0.233-0.3,0.267 l-0.301,0.083l0.084-0.4l0.267-0.067C16.75,8.983,16.8,9.033,16.767,9.167z"
}), React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "13.217,9.6 12.65,10.967 12.65,10.967 12.584,9.85 12.017,10 12.166,11.883 12.8,11.666  13.816,9.417 \t\t"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M11.133,10.283c-0.516,0.15-0.949,0.684-1.066,1.267c-0.05,0.284-0.017,0.5,0.083,0.65 c0.117,0.149,0.317,0.2,0.583,0.116C10.834,12.283,10.916,12.25,11,12.2l0,0c0.383-0.233,0.684-0.667,0.783-1.15 C11.916,10.45,11.65,10.133,11.133,10.283z M11.267,11.2c-0.083,0.433-0.316,0.6-0.45,0.634c-0.133,0.033-0.316,0-0.232-0.434 c0.082-0.434,0.299-0.601,0.449-0.634C11.166,10.733,11.35,10.767,11.267,11.2z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M1.367,10.017c0-4.683,3.8-8.5,8.5-8.5c4.683,0,8.5,3.8,8.5,8.5c0,4.684-3.801,8.5-8.5,8.5 C5.183,18.517,1.367,14.7,1.367,10.017L1.367,10.017z M17.434,7.733L8.05,10.717L6.333,17.1C7.4,17.633,8.6,17.934,9.867,17.934 c4.367,0,7.9-3.533,7.9-7.9C17.767,9.217,17.65,8.45,17.434,7.733L17.434,7.733z M7.783,2.383L5.45,11.117l2.05-0.65l1.383-5.184 l0.684-0.2l-1.4,5.167l9.15-2.9c-1.1-3.067-4.017-5.25-7.45-5.25C9.15,2.117,8.45,2.2,7.783,2.383L7.783,2.383z M2.25,12.133 l2.5-0.783l2.333-8.733c-3,1.133-5.117,4.017-5.117,7.4C1.967,10.75,2.067,11.467,2.25,12.133L2.25,12.133z M5.783,16.8l1.567-5.85 L5.317,11.6L4.7,13.867l-0.684,0.199l0.6-2.25l-2.25,0.717C2.967,14.316,4.183,15.834,5.783,16.8L5.783,16.8z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#6F6F6E",
  d: "M18.084,18.084c-0.15,0.166-0.234,0.35-0.234,0.582c0,0.234,0.084,0.418,0.234,0.584 c0.149,0.166,0.35,0.233,0.582,0.233c0.234,0,0.418-0.083,0.584-0.233c0.15-0.166,0.233-0.35,0.233-0.584 c0-0.232-0.083-0.416-0.233-0.582c-0.166-0.168-0.35-0.234-0.584-0.234C18.45,17.85,18.25,17.934,18.084,18.084L18.084,18.084z M19.35,19.334c-0.184,0.183-0.416,0.283-0.666,0.283c-0.268,0-0.483-0.101-0.667-0.283c-0.183-0.184-0.283-0.418-0.283-0.668 c0-0.266,0.101-0.482,0.283-0.666c0.184-0.184,0.399-0.283,0.667-0.283c0.267,0,0.482,0.1,0.666,0.283s0.283,0.4,0.283,0.666 C19.617,18.934,19.533,19.15,19.35,19.334L19.35,19.334z M18.85,18.3c-0.05-0.033-0.116-0.033-0.217-0.033h-0.149v0.384h0.167 c0.083,0,0.133,0,0.184-0.018c0.066-0.033,0.1-0.083,0.1-0.166C18.916,18.383,18.9,18.334,18.85,18.3L18.85,18.3z M18.65,18.15 c0.133,0,0.217,0.016,0.283,0.033c0.1,0.05,0.166,0.133,0.166,0.267c0,0.1-0.033,0.167-0.1,0.2c-0.033,0.016-0.084,0.033-0.15,0.05 c0.084,0.017,0.134,0.05,0.184,0.1c0.033,0.05,0.051,0.101,0.051,0.167v0.083c0,0.017,0,0.05,0,0.083s0,0.051,0.016,0.051V19.2 h-0.166c0,0,0,0,0-0.017c0,0,0,0,0-0.018v-0.033V19.05c0-0.116-0.033-0.2-0.1-0.233c-0.034-0.017-0.101-0.033-0.201-0.033h-0.149 V19.2H18.3v-1.05H18.65L18.65,18.15z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Livello_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve"
  }, props), React.createElement("g", null, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1743.877,
    y1: -2450.2373,
    x2: 1836.8506,
    y2: -2576.321,
    gradientTransform: "matrix(0.1667 0 0 -0.1667 -287.0836 -407.0833)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), React.createElement("stop", {
    offset: 0.5148,
    style: {
      "stopColor": "#D42D3F"
    }
  }), React.createElement("stop", {
    offset: 0.6616,
    style: {
      "stopColor": "#C72C3A"
    }
  }), React.createElement("stop", {
    offset: 0.9351,
    style: {
      "stopColor": "#A3292D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#9A2829"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#76231D"
    }
  })), _ref, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1744.5801,
    y1: -2451.2861,
    x2: 1835.8177,
    y2: -2575.0159,
    gradientTransform: "matrix(0.1667 0 0 -0.1667 -287.0836 -407.0833)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), React.createElement("stop", {
    offset: 0.2249,
    style: {
      "stopColor": "#D42D3F"
    }
  }), React.createElement("stop", {
    offset: 0.4595,
    style: {
      "stopColor": "#C72C3A"
    }
  }), React.createElement("stop", {
    offset: 0.8962,
    style: {
      "stopColor": "#A3292D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#9A2829"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#76231D"
    }
  })), _ref2, _ref3, _ref4, _ref5, _ref6));
};

export default __webpack_public_path__ + "static/media/hoover-logo.38a97153.svg";
export { SvgComponent as ReactComponent };